// Function to sort data based on order
function SortFinalData(data = [], order = []) {
    if (!order || !order.length || !data.length) {
        return data;
    }

    return [...data].sort((a, b) => {
        // Find the index in order for both items
        const indexA = order.findIndex((item) => item.productCode === a.title && item.coreDataId === a.coreDataId);
        const indexB = order.findIndex((item) => item.productCode === b.title && item.coreDataId === b.coreDataId);

        // Handle cases where items might not be in order
        if (indexA === -1 && indexB === -1) return 0;
        if (indexA === -1) return 1;
        if (indexB === -1) return -1;

        return indexA - indexB;
    });

    // return [...data].sort((a, b) => {
    // First, compare by coreDataId
    // if (a.coreDataId !== b.coreDataId) {
    //     return a.coreDataId - b.coreDataId; // Ascending order
    // }

    // // If coreDataId is the same, then compare by isCompetitorProduct (false < true)
    // if (a.isCompetitorProduct !== b.isCompetitorProduct) {
    //     return a.isCompetitorProduct - b.isCompetitorProduct;
    // }

    // // If both coreDataId and isCompetitorProduct are the same, then compare by title alphabetically
    // return a.title.localeCompare(b.title); // Alphabetical order
    // });
}

export default SortFinalData;
